<template>
    <admin-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-white">
                Slide
            </h2>
        </template>

        <div class="py-12">
            <div class="flex flex-col mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div class="flex w-full">
                    <div class="w-6/12 py-8 pr-12">
                        <h3 class="text-3xl font-bold text-white">Slideshow</h3>
                        <p class="py-2 text-white">In questa sezione puoi caricare le slide da visualizzare nella homepage dell'App.</p>
                    </div>
                    <div class="w-6/12 p-8 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                        <upload-slide @changeSlides="updatedSlides($event)"></upload-slide>
                    </div>
                </div>
                <!-- draagle slide  -->
                <draggable v-model="sliders" class="flex flex-col w-full mt-8">
                    <transition-group name="list-complete">
                        <div v-for="slide in sliders" :key="slide.id" @dragend="onDrop()">
                            <a :href="slide.url_link !== null ? slide.url_link : ''" :target="slide.url_link !== null ? '_blank' : ''">
                                <div class="flex w-full p-2 my-2 bg-white rounded-md cursor-pointer">
                                    <div v-bind:style="{ backgroundImage: 'url(' + slide.path + ')' }" class="w-3/12 h-24 bg-gray-100 bg-center bg-cover"></div>
                                    <div class="w-6/12 p-4"><h3 class="text-xl">{{ slide.name }}</h3></div>
                                    <div class="flex items-center content-center justify-center w-3/12 text-center">
                                        <div v-if="slide.status == 'waiting'" class="flex w-full">
                                            <form @submit.prevent="waitingStatus(slide.id)" class="w-6/12">
                                                <button type="submit" class="px-4 py-1 bg-yellow-200 rounded-lg">
                                                    {{ slide.status }}
                                                </button>
                                            </form>
                                            <form @submit.prevent="deleteSlide(slide.id)" class="w-6/12">
                                                <button class="flex items-center justify-center w-8 h-8 font-bold text-center text-white bg-red-400 rounded-full">x</button>
                                            </form>
                                        </div>
                                        <div v-if="slide.status == 'active'" class="w-full">
                                            <form @submit.prevent="activeStatus(slide.id)">
                                                <button type="submit"  class="px-4 py-1 bg-green-200 rounded-lg">
                                                    {{ slide.status }}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </div>
    </admin-layout>
</template>
<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import UploadSlide from '@/Components/UploadSlide'
    import Draggable from 'vuedraggable'

    export default {
        props: ['slides'],
        components: {
            AdminLayout,
            UploadSlide,
            Draggable
        },
        data() {
            return {
                submitted: false,
                active:{
                    id: '',
                    status: 'active',
                },
                waiting:{
                    id: '',
                    status: 'waiting',
                },
                sliders: this.slides
            }
        },
        methods: {
            activeStatus(id) {
                let custObj = this;
                const token = localStorage.getItem('token');
                const headers = { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
                axios.post("/slidestatus",{
                    id : id,
                    status : 'waiting'
                },{headers})
                .then(function (response) {
                    custObj.sliders = response.data.allSlides;
                })
                .catch(function (error) {
                    console.log(error);
                });
                // this.active.id = id;
                // this.$inertia.post(this.route('slidestatus'), this.active)
            },
            waitingStatus(id) {
                let custObj = this;
                const token = localStorage.getItem('token');
                const headers = { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
                axios.post("/slidestatus",{
                    id : id,
                    status : 'active'
                },{headers})
                .then(function (response) {
                    custObj.sliders = response.data.allSlides;
                })
                .catch(function (error) {
                    console.log(error);
                });

                // this.waiting.id = id;
                // this.$inertia.post(this.route('slidestatus'), this.waiting)
            },
            deleteSlide(id) {
                let custObj = this;
                const token = localStorage.getItem('token');
                const headers = { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
                axios.delete("/slidedelete/"+id,{headers})
                .then(function (response) {
                    custObj.sliders = response.data.allSlides;
                })
                .catch(function (error) {
                    console.log(error);
                });
                // this.waiting.id = id;
                // this.$inertia.delete( 'slidedelete/'+id)
            },
            onDrop() {
                this.$inertia.post(this.route('slidesequence'), {'slides' : this.sliders});
            },
            updatedSlides(value) {
                this.sliders = value;
            }
        },
    }
</script>

